// extracted by mini-css-extract-plugin
export default {"red":"Tasks_red__oKhE-","orange":"Tasks_orange__LCiQd"};